import { render } from "./AnnexAlarmSidebar.vue?vue&type=template&id=2719a234&ts=true"
import script from "./AnnexAlarmSidebar.vue?vue&type=script&lang=ts"
export * from "./AnnexAlarmSidebar.vue?vue&type=script&lang=ts"

import "./AnnexAlarmSidebar.vue?vue&type=style&index=0&id=2719a234&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__